module.exports = __webpack_public_path__ + "static/media/decline.f9c2f453.svg";